<template>
<div class="pb-4">
    <div class="grid grid-cols-3 gap-4 text-center text-20">
        <div @click="onclickTab(0)">
            <span class="cursor-pointer " :class="selectTab === 0 ? 'text-tc-blue-1' : 'text-tc-gray-3'">
                {{lbl.history.earn_tab}}
            </span>
            <div class="line-active text-center bg-tc-blue-1" v-if="selectTab === 0"></div>
        </div>
        <div @click="onclickTab(1)">
            <span class="cursor-pointer " :class="selectTab === 1 ? 'text-tc-blue-1 px-2' : 'text-tc-gray-3'">{{lbl.history.burn_tab}}</span>
            <div class="line-active text-center bg-tc-blue-1" v-if="selectTab === 1"></div>
        </div>
        <div @click="onclickTab(2)">
            <span class="cursor-pointer " :class="selectTab === 2 ? 'text-tc-blue-1 px-2' : 'text-tc-gray-3'">{{lbl.history.tranfer_tab}}</span>
            <div class="line-active text-center bg-tc-blue-1" v-if="selectTab === 2"></div>
        </div>
    </div>
    <div class="bg-tc-gray-4 line"></div>
</div>
</template>

<script>
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'Menutab',
    mixins: [LocaleMixin],
    data: function() {
        return {
            selectTab: 0
        };
    },

    created() {
        this.setTab();
    },

    methods: {
        setTab: function(){
            //console.log("this.$route.query", this.$route.query)
            if (window.location.pathname == '/carthistory') {
                this.onclickTab(1); //selectTab = 1 การใช้
            }
            else if(this.$route.query && this.$route.query.tab === 'redeem'){
                this.onclickTab(1);
            }else{
                this.onclickTab(0);
            }
        },
        onclickTab: function(tab){
            this.selectTab = tab
            this.$emit('onClick', this.selectTab);
        }
    },
};
</script>

<style lang="scss" scoped>
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
.line-active{
    height: 3px;
}
</style>
